import axios from 'axios'
import { ApiConfig } from '../../../../config/api'
import { OrderLabelCreateDto } from '../../../../interfaces/OrderLabel'
import { WorkOrderBlogCreateDto } from '../../../../interfaces/WorkOrder/WorkOrderBlog'
import { getCurrentDate } from '../../../../utils/dateHelper'

export const getOrderLabelList = (OrderId: number) => {
  const url = new URL(ApiConfig.OrderLabelApi)
  url.searchParams.set('OrderId', OrderId.toString())
  url.searchParams.set('pageIndex', '0')
  url.searchParams.set('pageSize', '100')
  return axios.get(url.toString())
}

export const getWorkOrder = (workOrderId: number) => {
  const url = new URL(`${ApiConfig.WorkOrderApi}/${workOrderId}`)
  return axios.get(url.toString())
}

export const createOrderLabel = (orderLabelDto: OrderLabelCreateDto) => {
  const url = new URL(ApiConfig.OrderLabelApi)
  return axios.post(url.toString(), orderLabelDto)
}

export const createWorkOrderBlog = (
  workOrderBlogCreateDto: WorkOrderBlogCreateDto
) => {
  const url = new URL(ApiConfig.WorkOrderBlog)
  return axios.post(url.toString(), workOrderBlogCreateDto)
}

export const patchOrderLabel = (orderLabelId: number) => {
  const url = new URL(`${ApiConfig.OrderLabelApi}`)
  url.searchParams.set('orderLabelId', orderLabelId.toString())
  return axios.patch(url.toString())
}

export const requestOrderLabel = (
  workOrderId: number,
  packageQuantity: string
) => {
  const url = new URL(`${ApiConfig.OrderLabelApi}/RequestLabel`)
  return axios.post(url.toString(), {
    workOrderId: workOrderId,
    packageQuantity: parseInt(packageQuantity)
  })
}

export const getPickingRoutes = (workOrderId: number) => {
  const url = new URL(
    `${ApiConfig.PickingRouteStatusApi}?WorkOrderId=${workOrderId}`
  )
  return axios.get(url.toString())
}

export const getTemporalLabel = (pickingId: number) => {
  const dateLocal = getCurrentDate()
  const url = new URL(
    `${ApiConfig.PickingRouteValidationApi}/GetTemporalLabel/${pickingId}?clientDate=${dateLocal}`
  )
  return axios.get(url.toString())
}

// Api pickingValidateFinishDetail
export const getValidateFinishDetail = (
  sku: string,
  pickingRouteId = 0,
  status: string,
  page = 0,
  pageSize = 5
) => {
  const url = new URL(
    `${ApiConfig.PickingRouteValidationApi}/GetPickingRouteValidationDetail?pickingRouteId=${pickingRouteId}`
  )

  if (sku !== '') {
    url.searchParams.set('Sku', sku)
  }

  if (status !== '') {
    const arrayStatusFilter = status.split('-')

    arrayStatusFilter.map((item: string) =>
      url.searchParams.append('status', item)
    )
  }

  url.searchParams.set('pageIndex', page.toString())
  url.searchParams.set('pageSize', pageSize.toString())

  return axios.get(url.toString())
}

export const getValidateFinishDetailVas = (
  sku: string,
  pickingRouteId = 0,
  status: string,
  page = 0,
  pageSize = 5
) => {
  const url = new URL(
    `${ApiConfig.PickingRouteValidationApi}/${pickingRouteId}/PickingRouteDeatilsSKUsWithVASRule`
  )

  if (sku !== '') {
    url.searchParams.set('Sku', sku)
  }

  if (status !== '') {
    const arrayStatusFilter = status.split('-')

    arrayStatusFilter.map((item: string) =>
      url.searchParams.append('status', item)
    )
  }

  url.searchParams.set('pageIndex', page.toString())
  url.searchParams.set('pageSize', pageSize.toString())

  return axios.get(url.toString())
}
